import { useEffect, useMemo, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { getFilterParams } from '@/metrics/helpers/helpers'
import metricsServices from '@/metrics/services/services'

import { defaultPageSize, defaultSentimentFilter, initialPage } from './constants'
import { getNotesParams } from './helpers'
import { transformResponseGetCustomerNotesByTopic } from './transformers'

const useTopicNotes = ({ reasonId, storeId, topicId, filters }) => {
  const [search, setSearch] = useState('')
  const [selectedSentimentFilter, setSelectedSentimentFilter] = useState(defaultSentimentFilter)
  const [page, setPage] = useState(initialPage)
  const [pageSize, setPageSize] = useState(defaultPageSize)

  const { data, loading, fetchData } = useFetch(metricsServices.getCustomerNotesByTopic, {
    doInitialRequest: false,
    transformResponse: transformResponseGetCustomerNotesByTopic,
  })

  const filterParams = useMemo(() => getFilterParams(filters), [filters])

  useEffect(() => {
    if (!topicId) return

    const params = getNotesParams({ filterParams, page, pageSize, search, selectedSentimentFilter })

    fetchData({ reasonId, storeId, topicId, params })
  }, [reasonId, storeId, topicId, filterParams, search, selectedSentimentFilter, page, pageSize, fetchData])

  const onChangeSearch = value => {
    setSearch(value)
    setPage(initialPage)
  }

  const onChangeSentimentFilter = value => {
    setSelectedSentimentFilter(value)
    setPage(initialPage)
  }

  const onChangePageSize = value => {
    setPageSize(value)
    setPage(initialPage)
  }

  const totalPages = data?.count ? Math.ceil(data.count / pageSize) : 0

  return {
    data,
    loading,
    search,
    onChangeSearch,
    selectedSentimentFilter,
    onChangeSentimentFilter,
    page,
    setPage,
    pageSize,
    onChangePageSize,
    totalPages,
  }
}

export default useTopicNotes
